const NextI18Next = require('next-i18next').default
const path = require('path')

const nextInstance = new NextI18Next({
  defaultLanguage: 'ja',
  otherLanguages: ['en'],
  localePath: path.resolve('./public/static/locales'),
  browserLanguageDetection: true,
  serverLanguageDetection: true,
  fallbackNS: 'common',
})

function useCustomTranslation(scope, ...props) {
  const { t, ...transProps } = nextInstance.useTranslation(...props)
  const translateWithScope = (key, ...props) =>
    t([scope, key].join('.'), ...props)

  return {
    i: strings => translateWithScope(strings.raw[0]),
    t: translateWithScope,
    ...transProps,
  }
}

module.exports = nextInstance
module.exports.useCustomTranslation = useCustomTranslation
module.exports.useTranslation = nextInstance.useTranslation
module.exports.withTranslation = nextInstance.withTranslation
module.exports.appWithTranslation = nextInstance.appWithTranslation
